// extracted by mini-css-extract-plugin
export default {"container":"DefaultIcon_container__Mmlfw"};